import React, { useState } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { Badge, createStyles, IconButton, ListItemIcon, Theme, Typography, withStyles } from "@material-ui/core";
import ListItem from "@material-ui/core/ListItem";
import Divider from "@material-ui/core/Divider";
import Link from "@material-ui/core/Link";
import { useSelector } from "react-redux";
import { State } from "../../store";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import Basket from "../../components/Basket";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    rootItem: {
      marginTop: 20,
      paddingLeft: 0,
      width: "100%",
      textAlign: "center",
      color: "#fff",
      backgroundColor: theme.palette.secondary.light,
      "&:hover": {
        backgroundColor: theme.palette.secondary.light,
      },
    },
    primaryText: {
      fontSize: 15,
      fontWeight: "bold",
      letterSpacing: 1,
    },
  })
);

const StyledBadge = withStyles((theme: Theme) =>
  createStyles({
    badge: {
      right: -3,
      top: 0,
      border: `2px solid ${theme.palette.background.paper}`,
      padding: "0 4px",
    },
  })
)(Badge);

const BasketButton: React.FC = () => {
  const classes = useStyles();
  const basket = useSelector((state: State) => state.basket.basket);
  const getBasketQnt = () => basket.reduce((acc: number, item) => acc + item.quantity, 0);
  const getBasketTotal = () => basket.reduce((acc: number, item) => acc + item.quantity * item.assort.listPrice, 0);
  const [showBasket, setShowBasket] = useState(false);

  return (
    <React.Fragment>
      <Link onClick={() => setShowBasket(true)} component={"li"} style={{ textDecoration: "none" }}>
        <ListItem button classes={{ root: classes.rootItem }}>
          <ListItemIcon style={{ marginLeft: "10%" }}>
            <IconButton aria-label="cart">
              <StyledBadge badgeContent={getBasketQnt()} color={"primary"}>
                <ShoppingCartIcon fontSize={"large"} style={{ color: "white" }} />
              </StyledBadge>
              <Typography style={{ color: "white", fontSize: 20, marginLeft: 10 }}>{`${getBasketTotal().toFixed(
                2
              )} `}</Typography>
            </IconButton>
          </ListItemIcon>
        </ListItem>
        <Divider />
      </Link>
      {showBasket && <Basket show={showBasket} onClose={() => setShowBasket(false)} />}
    </React.Fragment>
  );
};

export default BasketButton;
